import { createContext } from "react";
import { TabStateReturn } from "reakit/Tab";

export interface TabsContextShape extends TabStateReturn {
    onChange: (newId: string) => void;
    onlyRenderActiveTabPanelChildren: boolean;
}

// Gonna do something weird here with the context default value. This will NEVER be used since
// We require the Tab, TabList, and TabPanel to be used within Tabs.
export const TabsContext = createContext<TabsContextShape>({} as TabsContextShape);
